
import Vue from "vue";
import AppSelectSaleLayout from "@/components/SelectSaleLayout.vue";
import { TranslateResult } from "vue-i18n";

export default Vue.extend({
	props: {
		value: Number
	},
	computed: {
		title():{toString():string}{
			return `${this.$ct("common.print")}`;
		},
		confirmText():TranslateResult{
			return this.$ct("common.print");
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async print(){
			this.$emit("print");
		},
		onInput(id:number){
			this.$emit("input",id);
		}
	},
	mounted(){
	},
	components: {
		AppSelectSaleLayout
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
